import React, {useState} from 'react';
import { View, Text, TouchableOpacity, StyleSheet, Dimensions, Image, TouchableWithoutFeedback } from 'react-native';
import { Icon } from 'react-native-elements';
import { useSelector } from 'react-redux';
import { getComponentColor, getLoading } from '../reducers/configSlice';
import { MaterialIndicator } from 'react-native-indicators';
import { FONT_FAMILY, FONT_FAMILY_BOLDER, FONT_FAMILY_LIGHT } from '../constants/styleConstants';
import { actuatedNormalize, proportionalSize } from '../services/helpers/stylingHelpers';
import {isWEB} from "../services/helpers/getPlatformType";

const CustomModal = ({ visible, onClose, children, merged = false, icon, title, subtitle, disabled, buttonText, onButtonPress }) => {
    const componentColor = useSelector(getComponentColor);
    const loading = useSelector(getLoading);

    const [width, setWidth] = useState(Dimensions.get('screen').width)
    const [height, setHeight] = useState(Dimensions.get('screen').height)

    const onLayout = () => {
        setWidth(Dimensions.get('screen').width)
        setHeight(Dimensions.get('screen').height)
    };

    if (!visible) return null;  // Render nothing if not visible

    return (
        <TouchableWithoutFeedback onPress={onClose}>
            <View style={styles.overlay}>
                <TouchableWithoutFeedback onPress={() => {}}>
                    <View style={
                        [styles.container, !merged ?
                            { height: width > height ? '76%' : '56%', width: width > height ? '50%' : '70%'} :
                            { height: width > height ? '42%' : '32%', width: width > height ? '50%' : '70%'}
                        ]} onLayout={onLayout}
                    >
                        <View style={merged ? styles.modalHeaderMerged : styles.modalHeader}>
                            {icon ? (
                                <View style={[styles.iconContainer]}>
                                    <Image style={styles.icon} source={icon} />
                                </View>
                            ) : null}
                            <Icon size={proportionalSize(24)} onPress={onClose} name="close" type="antdesign" color="#E3E3E3" containerStyle={styles.xButton} />
                            <View style={styles.contentContainer}>
                                <Text style={styles.title}>
                                    {title}
                                </Text>
                                <Text style={styles.description}>
                                    {subtitle}
                                </Text>
                            </View>
                        </View>
                        {children}
                        <View style={merged ? styles.modalFooterMerged : styles.modalFooter}>
                            <TouchableOpacity onPress={onButtonPress} disabled={disabled || loading} style={[styles.button, { backgroundColor: componentColor }, (loading || disabled) && { opacity: 0.5 }]}>
                                <Text style={styles.buttonText}>
                                    {buttonText}
                                </Text>
                                {loading && <MaterialIndicator style={styles.loadingIndicator} size={actuatedNormalize(15)} trackWidth={2} color={'white'} />}
                            </TouchableOpacity>
                        </View>
                    </View>
                </TouchableWithoutFeedback>
            </View>
        </TouchableWithoutFeedback>
    );
};

const styles = StyleSheet.create({
    overlay: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1000,
    },
    container: {
        alignSelf: 'center',
        backgroundColor: '#FFFFFF',
        borderRadius: 3,
    },
    modalHeaderMerged: {
        flex: 0.62,
        alignItems: 'center',
    },
    modalHeader: {
        flex: 0.34,
        alignItems: 'center',
        backgroundColor: '#F8F9FA',
    },
    modalFooter: {
        flex: 0.24,
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#F8F9FA',
        borderTopWidth: 1,
        borderTopColor: '#E4EAEC',
        borderBottomLeftRadius: 3,
        borderBottomRightRadius: 3,
    },
    modalFooterMerged: {
        flex: 0.38,
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#F8F9FA',
        borderTopWidth: 1,
        borderTopColor: '#E4EAEC',
        borderBottomLeftRadius: 3,
        borderBottomRightRadius: 3,
    },
    button: {
        height: '41%',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 2.5,
        width: isWEB() ? '50%' : 'auto'
    },
    buttonText: {
        paddingLeft: '10%',
        paddingRight: '10%',
        color: 'white',
        fontFamily: FONT_FAMILY,
        fontSize: actuatedNormalize(10),
    },
    iconContainer: {
        marginTop: actuatedNormalize(18),
    },
    icon: {
        height: actuatedNormalize(38),
        width: actuatedNormalize(38),
    },
    xButton: {
        position: 'absolute',
        right: actuatedNormalize(14),
        top: actuatedNormalize(14),
    },
    contentContainer: {
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
    },
    title: {
        paddingBottom: '2%',
        fontFamily: FONT_FAMILY_BOLDER,
        fontSize: actuatedNormalize(18),
    },
    description: {
        color: '#928e8e',
        fontFamily: FONT_FAMILY_LIGHT,
        fontSize: actuatedNormalize(11),
        maxWidth: '75%',
        textAlign: 'center',
    },
    loadingIndicator: {
        position: 'absolute',
        right: '3%',
    },
});

export default CustomModal;
